export const DELAY = '0-1';
export const TASK = '0-3';
export const EMAIL = '0-4';
export const SET_PROPERTY = '0-5';
export const STATIC_BRANCH = '0-6';
export const LIST_BRANCH = '0-7';
export const EMAIL_NOTIFICATION = '0-8';
export const IN_APP_NOTIFICATION = '0-9';
export const SLACK_NOTIFICATION = '0-10';
export const ROTATE_OBJECT = '0-11';
export const WEBHOOK = '0-12';
export const ALTER_LIST_MEMBERSHIP = '0-13';
export const CREATE_OBJECT = '0-14';
export const ENROLL_IN_FLOW = '0-15';
export const EXTENSION = '0-16';
export const UPDATE_EMAIL_SUBSCRIPTION = '0-17';
export const CREATE_SALESFORCE_CAMPAIGN = '0-18';
export const CREATE_SALESFORCE_TASK = '0-19';
export const SEND_SMS_NOTIFICATION = '0-20';
export const CLASSIC_ENROLL_IN_WORKFLOW = '0-21';
export const CLASSIC_ALTER_LIST_MEMBERSHIP = '0-22';
export const CLASSIC_NOTIFICATION_EMAIL = '0-23';
export const CLASSIC_COPY_COMPANY_PROPERTY = '0-25';
export const CLASSIC_ANCHORED_DELAY = '0-28';
export const WAIT_UNTIL = '0-29';
export const ADS_AUDIENCE_MEMBERSHIP = '0-30';
export const SET_MARKETING_STATUS = '0-31';
export const CUSTOM_CODE = '0-32';
export const FORMULA = '0-33';
export const DELAY_UNTIL_DATE = '0-35';
export const WHILE_LOOP = '0-36';
export const AB_TEST_BRANCH = '0-37';